import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RiskBadge } from "@/components/ui/risk-badge";
import { StatusBadge } from "@/components/ui/status-badge";

/* ThemeSmoke — Phase 3 verification page.
   Renders token primitives so we can eyeball that:
   - Lato loads (heading + body)
   - Aubergine token resolves
   - Teal focus-visible ring shows on Tab
   - RiskBadge renders all four bands
   - StatusBadge renders all three states
   - Card has soft Aubergine-tinted shadow, no top stripe / left accent
   No product logic — safe to leave linked from /theme-smoke forever. */

export default function ThemeSmoke() {
  return (
    <div style={{ padding: 32, maxWidth: 960, margin: "0 auto", fontFamily: "Lato, system-ui, sans-serif" }}>
      <h1 style={{ fontFamily: "Lato, system-ui, sans-serif", fontSize: 32, fontWeight: 700, marginBottom: 8 }}>
        ThemeSmoke
      </h1>
      <p style={{ fontFamily: "Lato, system-ui, sans-serif", marginBottom: 24 }}>
        Phase 3 token verification. Inspect each section in DevTools.
      </p>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>1. Lato font</h2>
        <p>
          Heading + body should render in Lato. Inspect element &rarr; Computed &rarr; font-family.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>2. Aubergine sidebar token</h2>
        <div className="bg-aubergine text-white p-4 rounded">Aubergine #322B44</div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>3. Teal focus ring</h2>
        <p style={{ marginBottom: 8 }}>Tab to the button below — focus ring should be 3px teal.</p>
        <Button>Tab to me</Button>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>4. RiskBadge — all four bands</h2>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <RiskBadge band="low" />
          <RiskBadge band="moderate" />
          <RiskBadge band="high" />
          <RiskBadge band="more_info" />
        </div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>5. StatusBadge — all three states</h2>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <StatusBadge status="completed" />
          <StatusBadge status="partial" />
          <StatusBadge status="notstarted" />
        </div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>6. Card — soft Aubergine-tinted shadow</h2>
        <Card>
          <CardHeader>
            <CardTitle>Card title</CardTitle>
            <CardDescription>Sample description.</CardDescription>
          </CardHeader>
          <CardContent>
            <p>No top stripe, no left border accent. White surface, 1px subtle border, soft shadow.</p>
          </CardContent>
        </Card>
      </section>
    </div>
  );
}
